// extracted by mini-css-extract-plugin
export var aboveInput = "_mg-0";
export var actionButton = "_mg-5";
export var actionButtonContainer = "_mg-1";
export var actionIcon = "_mg-6";
export var aiInfoContainer = "_mg-2";
export var attachmentWrapper = "_mg-7";
export var bold = "_mg-3";
export var checkIcon = "_mg-8";
export var clickingRecipientBar = "_mg-11";
export var commentThreadSwitch = "_mg-a";
export var draftImage = "_mg-b";
export var draftImageContainer = "_mg-c";
export var draftImages = "_mg-e";
export var editButton = "_mg-g";
export var editor = "_mg-f";
export var editorContainer = "_mg-y";
export var editorErrorTooltipWrapper = "_mg-9";
export var headerDivider = "_mg-h";
export var icon = "_mg-i";
export var info = "_mg-j";
export var internal = "_mg-n";
export var internalDivider = "_mg-k";
export var internalMessage = "_mg-l";
export var messageInputCard = "_mg-m";
export var messageInputForm = "_mg-o";
export var messageInputFormInternal = "_mg-p";
export var options = "_mg-q";
export var publicMessageCustomer = "_mg-s";
export var publicMessageMerchant = "_mg-r";
export var removeImageButton = "_mg-d";
export var replyButtons = "_mg-t";
export var showSignatureButton = "_mg-u";
export var spinner = "_mg-v";
export var verticalButtonDivider = "_mg-4";
export var visibilitySelector = "_mg-w";
export var warning = "_mg-x";
export var wrappingText = "_mg-z";
export var writingInternalNoteTopBorder = "_mg-10";